import React, { memo } from "react";
import "swiper/css";
import "swiper/css/free-mode";
import "swiper/css/navigation";
import "./SectorSolutionsSlider.css";
import { Swiper, SwiperSlide } from "swiper/react";
import { Autoplay, FreeMode, Navigation } from "swiper/modules";
import { Fade } from "react-awesome-reveal";
import { useNavigate } from "react-router-dom";
import { useTranslation } from "react-i18next";
import { AboutUsBg } from "../../assets/img";

const renderSwiperSlide = (sector, navigate, idx) => (
	<SwiperSlide key={idx}>
		<Fade direction='up' triggerOnce={true}>
			<div
				onClick={() => navigate(`/solutions/${sector?.id}`)}
				className='sector-slide h-[340px] group custom-transition border-[1px] border-slate-300 shadow-md rounded-lg relative cursor-pointer'>
				<div className='h-[250px] mb-5 overflow-hidden'>
					<img
						className='group-hover:translate-y-2 group-hover:scale-125 custom-transition h-auto w-full rounded-ss-lg rounded-se-lg'
						src={sector?.image}
						alt={sector?.title || "Solution Image"}
					/>
				</div>
				<h3
					onClick={() => navigate(`/solutions/${sector?.id}`)}
					className='text-[22px] text-slate-700 hover:text-slate-900 font-normal text-center webkit-line-clamp-title'>
					{sector?.title}
				</h3>
				<div className='circle-shape1 bg-white w-full'>
					<img loading='lazy' src={AboutUsBg} alt='Background' />
				</div>
			</div>
		</Fade>
	</SwiperSlide>
);

const SectorSolutionsSlider = memo(({ data }) => {
	const navigate = useNavigate();
	const { i18n } = useTranslation();
	const swiperConfig = {
		slidesPerView: 1,
		spaceBetween: 20,
		freeMode: true,
		navigation: true,
		loop: true,
		dir: i18n?.language === "ar" ? "rtl" : "ltr",
		autoplay: {
			delay: 2200,
			disableOnInteraction: false,
		},
		breakpoints: {
			768: { slidesPerView: 3, spaceBetween: 20 },
		},
		modules: [FreeMode, Navigation, Autoplay],
		className: "sector-slides h-auto md:h-[360px] z-10 md:mb-0 mb-6",
	};

	return (
		<Swiper {...swiperConfig}>
			{data?.map((sector, idx) => renderSwiperSlide(sector, navigate, idx))}
		</Swiper>
	);
});

export default SectorSolutionsSlider;
